import { useEffect } from 'react'
import { Outlet, useParams, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { applyDirection } from '@/i18n/config'
import { isSupportedLang, DEFAULT_LANG } from '@/utils/localeFromUrl'

/**
 * Renders under Route path=":lang". Syncs URL lang to i18n and applies direction.
 * Redirects to default lang if :lang is invalid.
 */
export default function LangSync() {
  const { lang: langParam } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()
  const lang = (langParam || '').toLowerCase()

  useEffect(() => {
    if (!lang) return
    const base = i18n.language?.split('-')[0] || ''
    if (base !== lang) {
      i18n.changeLanguage(lang)
      try {
        localStorage.setItem('i18nextLng', lang)
      } catch {}
    }
    applyDirection(lang)
  }, [lang, i18n])

  if (!langParam || !isSupportedLang(langParam)) {
    return <Navigate to={`/${DEFAULT_LANG}`} replace />
  }

  return <Outlet />
}
